import { createFileRoute } from '@tanstack/react-router'
import ReviewQuotesSection from 'Work/components/Work/Sections/ReviewQuotes/ReviewQuotesSection'

export const Route = createFileRoute('/work/$workId/review-quotes')({
    component: ReviewQuotesSection,
})
